import { ekanalys_ekanalys_columns } from '../../../../../../Queries/EkonomiskAnalysSettingsQuery/_QueryTypes/ekanalys';
import {
  EkonomiskAnalysEditColumnFormValuesType,
  BudgetTypes,
  ColumnFaltkodType,
} from '../Components/EkonomiskAnalysEditColumnForm';
import { StandardColumnType } from '../Components/Queries/EkonomiskAnalysStandardColumnQuery/EkonomiskAnalysStandardColumnQuery';
import {
  getStandardColumnTitle,
  findStandardColumnByFaltkod,
  getStandardColumnSubTitle,
} from './EkonomiskAnalysEditColumnUtils';
import { IEkonomiskAnalysDates } from '../../../../../AnalysSettingsHandler/AnalysSettingsHandler';

export const convertColumnTime = (
  isAbsolute: boolean,
  referenceTime: number,
  time: number | null
): number | null => {
  if (time == null || isAbsolute) {
    return time;
  } else {
    return referenceTime + time;
  }
};

const convertTitle = (
  column: ekanalys_ekanalys_columns,
  standardColumn: StandardColumnType | undefined
): string => {
  if (column.BENAMNING) {
    return column.BENAMNING;
  } else {
    return getStandardColumnTitle(standardColumn);
  }
};

const convertSubTitle = (
  column: ekanalys_ekanalys_columns,
  standardColumn: StandardColumnType | undefined,
  fromPeriodChecked: boolean,
  tomPeriodChecked: boolean
): string => {
  if (column.BENAMNING2) {
    return column.BENAMNING2;
  } else {
    return getStandardColumnSubTitle(
      standardColumn,
      fromPeriodChecked,
      tomPeriodChecked
    );
  }
};

const isBudgetType = (budgetType: string): budgetType is BudgetTypes =>
  budgetType === BudgetTypes.all ||
  budgetType === BudgetTypes.category ||
  budgetType === BudgetTypes.specific;

const budgetTypeFromString = (budgetTypeString: string | null): BudgetTypes => {
  if (budgetTypeString != null && isBudgetType(budgetTypeString)) {
    return budgetTypeString;
  }

  return BudgetTypes.all;
};

interface IEditColumnFormReferenceDates {
  fromYear: number;
  fromMonth: number;
  toYear: number;
  toMonth: number;
}

const emptyReferenceDates: IEditColumnFormReferenceDates = {
  fromYear: 0,
  fromMonth: 0,
  toYear: 0,
  toMonth: 0,
};

export const getReferenceDates = (
  referenceDates: IEkonomiskAnalysDates
): IEditColumnFormReferenceDates => {
  if (referenceDates.from.year == null || referenceDates.from.month == null) {
    return emptyReferenceDates;
  } else {
    return {
      fromYear: referenceDates.from.year,
      fromMonth: referenceDates.from.month,
      toYear:
        referenceDates.to.year != null
          ? referenceDates.to.year
          : referenceDates.from.year,
      toMonth:
        referenceDates.to.month != null
          ? referenceDates.to.month
          : referenceDates.from.month,
    };
  }
};

export const columnToEditColumnFormValues = (
  column: ekanalys_ekanalys_columns,
  standardColumns: StandardColumnType[],
  referenceDates: IEkonomiskAnalysDates
): EkonomiskAnalysEditColumnFormValuesType => {
  const fromArChecked = !column.FROM_AR_RELATIV;
  const tomArChecked = !column.TOM_AR_RELATIV;
  const fromPeriodChecked = !column.FROM_PER_RELATIV;
  const tomPeriodChecked = !column.TOM_PER_RELATIV;

  const standardColumn = findStandardColumnByFaltkod(
    column.FALTKOD as ColumnFaltkodType,
    standardColumns
  );

  let { fromYear, fromMonth, toYear, toMonth } =
    getReferenceDates(referenceDates);

  if (standardColumn && standardColumn.INGAENDE) {
    toMonth = fromMonth;
  }

  return {
    columnOrigin: column.FALTKOD as ColumnFaltkodType,
    displayLabel: '',
    title: convertTitle(column, standardColumn),
    subTitle: convertSubTitle(
      column,
      standardColumn,
      fromPeriodChecked,
      tomPeriodChecked
    ),
    columnType: column.FALT_TYP,
    columnUnit: column.ENHET_ID,
    timeInterval: column.INTERVALL_TYP,
    fromAr: convertColumnTime(fromArChecked, fromYear, column.FROM_AR),
    fromArChecked,
    fromPeriod: convertColumnTime(
      fromPeriodChecked,
      fromMonth,
      column.FROM_PER
    ),
    fromPeriodChecked,
    tomAr: convertColumnTime(tomArChecked, toYear, column.TOM_AR),
    tomArChecked,
    tomPeriod: convertColumnTime(tomPeriodChecked, toMonth, column.TOM_PER),
    tomPeriodChecked,
    budget: column.BUDGETBENAMNING,
    budgetType: budgetTypeFromString(column.BUDGETTYP),
    flipSign: column.VAND_TECKEN || false,
    rullande: column.RULLANDE,
  };
};
